import React from 'react';
import PropTypes from 'prop-types';
import { get, has } from 'lodash';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Image } from '@bd/bdcore-utilities';
import LightBox from '@bd/bdui-lightbox';

const styles = css`
  width: 100%;
  background-color: #FFFFFF;
  padding: 0;
  margin: 0;
  @media (min-width: 992px) {
    margin: 0;
  }
  .Carousel_thumbnailsWrapper {
    display: none;
    position: relative;
    @media (min-width: 992px) {
      display: block;
      margin: 0;
    }
  }
  .Carousel_overlay {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  font-weight: 800;
  font-size: 12px;
  color: #FFFFFF;
  letter-spacing: 0;
  display: none;
  justify-content: center;
  align-items: center;
  animation: fadeIn .3s;
  @media(min-width: 768px) {
    font-size: 18px;
  }
}
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    white-space: nowrap;
    overflow-x: scroll;
    scroll-behavior: smooth;
  }
  .Carousel_thumbnailItem {
      display: inline-block;
      white-space: nowrap;
      position: relative;
      width: 25%;
      background-color: transparent;
      cursor: pointer;
      &:focus {
        outline: none;
      }
      &:nth-child(4) {
        .Carousel_overlay {
          display: flex;
        }
      }
    }
  .Carousel_thumbnailItem:after {
    display: none;
    content: " ";
    top: auto;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    pointer-events: none;
  }
  .Carousel_thumbnailItem-active:after {
    display: block;
  }
  img {
    width: 100%;
    height: auto;
  }
  .Carousel_videoOverlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,.5);
    background-image: url('/images/i-play.svg');
    background-position: center center;
    background-size: 32px 32px;
    background-repeat: no-repeat;
  }
  .Carousel_tourOverlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url('/images/i-tour.svg');
    background-position: center center;
    background-size: auto 34px;
    background-repeat: no-repeat;
  }
  .Carousel_image {
    position: relative;
    padding-bottom: 56.25%;
    height:100%;
    overflow:hidden;
    display: flex;
    justify-content: center;
  }
    img {
      position: absolute;
      top: 0;
      bottom: 0;
      height:100%;
      width:auto;
      @media(max-width: 624px){
      }
    }
    .Carousel_imageElement {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      margin: 0;
      padding: 0;
      width: 100%;
    }
    iframe {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .Carousel_imageButtonLeft,
  .Carousel_imageButtonRight {
    position: absolute;
    display: block;
    top: 40%;
    width: 40px;
    height: 40px;
    background-size: 25px 25px;
    background-position: center center;
    background-repeat: no-repeat;
    z-index: 2;
    cursor: pointer;
    @media (min-width: 992px) {
      top: 45%;
      background-size: 25px 25px;
    }
  }
  .Carousel_imageButtonLeft {
    left: 5px;
  }
  .Carousel_imageButtonRight {
    right: 5px;
  }
  .Carousel_imageButtonLeft-light {
    background-image: url(/images/i-arrow-left-white.svg);
  }
  .Carousel_imageButtonLeft-dark {
    background-image: url(/images/i-arrow-left-dark.svg);
  }
  .Carousel_imageButtonRight-light {
    background-image: url(/images/i-arrow-right-white.svg);
  }
  .Carousel_imageButtonRight-dark {
    background-image: url(/images/i-arrow-right-dark.svg);
  }
  .Carousel_imageEnlargeButton {
    background-image: url(/images/i-enlarge-white.svg);
    background-position: center center;
    background-size: 27px 27px;
    background-repeat: no-repeat;
    position: absolute;
    display: block;
    width: 30px;
    height: 30px;
    right: 10px;
    bottom: 10px;
    cursor: pointer;
    z-index: 2;
  }
`;


class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: props.items[0],
      overlay: true,
    };

    this.pause = false;
  }

  componentDidMount() {
    if (this.props.autoplay) {
      this.interval = setInterval(this.handleInterval, this.props.interval);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setThumbnailListRef = ref => {
    this.thumbnailListRef = ref;
  }

  handleThumbnailClick = item => event => {
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    this.setState({
      currentSlide: item,
    });
  }

  handlePrevClick = (event = {}) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    const { items } = this.props;
    const { currentSlide } = this.state;
    const currentIndex = items.indexOf(currentSlide);
    const prevIndex = (currentIndex + (items.length - 1)) % items.length;
    this.setState({
      currentSlide: items[prevIndex],
    }, this.scrollToActive);
  }

  handleNextClick = (event = {}) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }

    const { items } = this.props;
    const { currentSlide } = this.state;
    const currentIndex = items.indexOf(currentSlide);
    const nextIndex = (currentIndex + 1) % items.length;
    this.setState({
      currentSlide: items[nextIndex],
    }, this.scrollToActive);
  }

  handleInterval = () => {
    if (!this.pause) {
      this.handleNextClick();
    }
  }

  handleMouseEnter = () => {
    this.pause = true;
  }

  handleMouseLeave = () => {
    this.pause = false;
  }

  handleTouchStart = event => {
    this.xDown = event.touches[0].clientX;
    this.xDownTime = Date.now();
  }

  handleTouchEnd = event => {
    const swipeDifference = this.xDown - event.changedTouches[0].clientX;

    if (Date.now() - this.xDownTime < 50) {
      event.target.click();
      return;
    }

    if (swipeDifference > 25) {
      this.handleNextClick();
    } else if (swipeDifference < -25) {
      this.handlePrevClick();
    }
  }

  scrollToActive = () => {
    if (this.thumbnailListRef) {
      const [{ offsetLeft = 0, offsetWidth: thumbWidth }] = this.thumbnailListRef.getElementsByClassName('Carousel_thumbnailItem-active');
      const containerWidth = this.thumbnailListRef.offsetWidth;
      const scrollLeft = this.thumbnailListRef.scrollLeft;

      if ((offsetLeft + thumbWidth) > (
        containerWidth + scrollLeft
      )) {
        this.thumbnailListRef.scrollLeft = offsetLeft;
      } else if (offsetLeft < scrollLeft) {
        this.thumbnailListRef.scrollLeft = (offsetLeft + thumbWidth) - containerWidth;
      }
    }
  }

  handleAddClassOnScroll = () => {
    const { overlay } = this.state;
    const ref = this.thumbnailListRef;
    if (ref.scrollLeft > 15 && overlay === true) {
      this.setState({
        overlay: false,
      });
    } else if (ref.scrollLeft < 15 && overlay === false) {
      this.setState({
        overlay: true,
      });
    }
  };

  render() {
    const {
      canEnlarge,
      className,
      darkButtons,
      items,
      thumbnails,
      thumbnailImageProps,
      mainImageProps,
      typeLabel,
    } = this.props;
    const { currentSlide, overlay } = this.state;

    return (
      <div
        className={cx(styles, className)}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div
          className="Carousel_image"
          onTouchStart={this.handleTouchStart}
          onTouchMove={this.handleTouchMove}
          onTouchEnd={this.handleTouchEnd}
        >
          {
            has(currentSlide, 'contentUrl') &&
            <Image
              src={get(currentSlide, 'contentUrl')}
              alt={get(currentSlide, 'name', get(currentSlide, 'caption', ''))}
              {...mainImageProps}
            />
          }
          {
            has(currentSlide, 'element') &&
            get(currentSlide, 'element')
          }
          {
            items.indexOf(currentSlide) > 0 &&
            <div
              role="button"
              tabIndex="0"
              onClick={this.handlePrevClick}
              onKeyUp={this.handlePrevClick}
              className={[
                'Carousel_imageButtonLeft',
                darkButtons ? 'Carousel_imageButtonLeft-dark' : 'Carousel_imageButtonLeft-light',
              ].join(' ')}
            />
          }
          {
            items.length > 1 &&
            (items.indexOf(currentSlide) + 1) < items.length &&
            <div
              role="button"
              tabIndex="0"
              onClick={this.handleNextClick}
              onKeyUp={this.handleNextClick}
              className={[
                'Carousel_imageButtonRight',
                darkButtons ? 'Carousel_imageButtonRight-dark' : 'Carousel_imageButtonRight-light',
              ].join(' ')}
            />
          }
          {
            canEnlarge &&
            <LightBox items={items}>
              <div className="Carousel_imageEnlargeButton" data-index={items.indexOf(currentSlide)} />
            </LightBox>
          }
        </div>
        {
          thumbnails &&
          <div className="Carousel_thumbnailsWrapper">
            <ul ref={ref => this.setThumbnailListRef(ref)}>
              {
                items.map((item, i) => (
                  <li key={i.toString()} className={`Carousel_thumbnailItem ${currentSlide === item ? 'Carousel_thumbnailItem-active' : ''}`}>
                    <span
                      role="button"
                      tabIndex="0"
                      onClick={this.handleThumbnailClick(item)}
                      onKeyUp={this.handleThumbnailClick(item)}
                    >
                      {
                        has(item, 'contentUrl') &&
                        <Image
                          src={get(item, 'contentUrl')}
                          alt={get(item, 'name', get(item, 'caption', ''))}
                          {...thumbnailImageProps}
                        />
                      }
                      {
                        !has(item, 'contentUrl') &&
                        <Image
                          src={get(items, '[0]contentUrl')}
                          alt={get(items, '[0]name', get(items, '[0]caption', ''))}
                          {...thumbnailImageProps}
                        />
                      }
                      {
                        item.type === 'video' &&
                        <div className="Carousel_videoOverlay" />
                      }
                      {
                        item.type === 'tour' &&
                        <div className="Carousel_tourOverlay" />
                      }
                      {
                        items.length - (i + 1) > 0 && item !== null &&
                        <div className={`Carousel_overlay  ${!overlay ? 'Carousel_overlayAlt' : ''}`}>+{items.length - (i + 1)} {typeLabel}</div>
                      }
                    </span>
                  </li>
                ))
              }
            </ul>
          </div>
        }
      </div>
    );
  }
}

Carousel.propTypes = {
  autoplay: PropTypes.bool,
  canEnlarge: PropTypes.bool,
  className: PropTypes.string,
  darkButtons: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    contentUrl: PropTypes.string,
    element: PropTypes.node,
    name: PropTypes.string,
    caption: PropTypes.string,
  })).isRequired,
  thumbnails: PropTypes.bool,
  mainImageProps: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    exact: PropTypes.bool,
    preserve: PropTypes.bool,
  }),
  thumbnailImageProps: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    exact: PropTypes.bool,
    preserve: PropTypes.bool,
  }),
  interval: PropTypes.number,
  typeLabel: PropTypes.string,
};

Carousel.defaultProps = {
  autoplay: false,
  canEnlarge: true,
  className: undefined,
  darkButtons: false,
  mainImageProps: undefined,
  thumbnails: false,
  thumbnailImageProps: undefined,
  interval: 3000,
  typeLabel: '',
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel.js